import Vue from 'vue'
import Rollbar from 'vue-rollbar'

const rollbarConfig = {
  accessToken: process.env.ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging',
  source_map_enabled: true,
  environment: process.env.NODE_ENV,
  payload: {
    client: {
      javascript: {
        code_version: '1.0'
      }
    }
  }
}

const rollbarInitializer = () => { Vue.use(Rollbar, rollbarConfig) }

export default rollbarInitializer



// WEBPACK FOOTER //
// ./src/services/rollbar.js